import { CryptoService } from './../../../core/services/crypto/crypto.service';
import { Component, Injectable, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { take } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { EditMyUserComponent } from '../edit-my-user/edit-my-user.component';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';

import {
  User,
  Fund,
} from '../visualizar-usuario/master-visualizar-usuario.model';
import { MasterVisualizarMeuCadastroService } from './master-visualizar-meu-cadastro.service';
import { InvestmentFunds } from '../visualizar-usuario/master-visualizar-usuario.model';
import { MatDialogRef, MatDialog, MatDialogConfig } from '@angular/material/dialog';

@Component({
  selector: 'app-master-visualizar-meu-cadastro',
  templateUrl: './master-visualizar-meu-cadastro.component.html',
})

@Injectable()
export class MasterVisualizarMeuCadastroComponent implements OnInit {
  user: User;
  panelOpenState = false;
  dialogConfig: any;

  fundsColumns = ['code', 'name'];

  @ViewChildren(MatSort) sortFunds = new QueryList<MatSort>();
  sortTopProfitability: MatSort;

  protected onClose(): void { }

  constructor(
    public dialogRef: MatDialogRef<MasterVisualizarMeuCadastroComponent>,
    private masterVisualizarMeuCadastroService: MasterVisualizarMeuCadastroService,
    private dialog: MatDialog,
    private msalService: MsalService,
    private shared:SharedVariable

  ) { }

  ngOnInit() {
    this.getUser(this.shared.mailUser);

    // TODO: to refactor
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';
    this.dialogConfig.position = {
      top: '43px',
    };
  }

  getUser(email: string) {
    let objectEmail = {"email":email};

    this.masterVisualizarMeuCadastroService
      .getUserByEmail(objectEmail)
      .subscribe(response => {
        this.user = response;
        this.user.investmentGroups.naturalSort(['name']);

        if (this.user.nationality == 'Residente') {
          this.user.documentNumber = this.user.documentNumber.replace(
            /(\d{3})(\d{3})(\d{3})(\d{2})/g,
            '$1.$2.$3-$4',
          );
        }

        this.user.internationalPrefix =
          this.user && this.user.internationalPrefix
            ? this.user.internationalPrefix.substr(2, 3)
            : '';

        this.user.cellNumber =
          this.user && this.user.cellNumber
            ? this.user.cellNumber.replace(
              /(\d{2})(\d{5})(\d{4})/g,
              '($1)$2-$3',
            )
            : ' ';

        this.user.internationalPrefix =
          this.user && this.user.internationalPrefix
            ? this.user.internationalPrefix.substr(2, 3)
            : '';

        this.user.cellNumber =
          this.user && this.user.cellNumber
            ? this.user.cellNumber.replace(
              /(\d{2})(\d{5})(\d{4})/g,
              '($1)$2-$3',
            )
            : ' ';
      });
  }

  sort(array: Array<any>) {
    let arraySorted = [...array].reverse();
    array.reverse();

    arraySorted.naturalSort(['code'], true);
    return arraySorted;
  }

  doFechar() {
    this.dialogRef.close();
  }

  instanceDataSource(arr, index) {
    const dataSource = new MatTableDataSource<InvestmentFunds>(
      arr.naturalSort(['code']),
    );

    dataSource.sortingDataAccessor = (data, sortHeaderId) =>
      data[sortHeaderId].naturalNormalize();
    dataSource.sort = this.sortFunds.toArray()[index];
    return dataSource;
  }

  openMyProfile(): void {
    this.dialog
      .open(EditMyUserComponent, this.dialogConfig)
      .afterClosed()
      .subscribe(result => {
        this.dialogConfig.data = null;
        if (result) {
          this.getUser(this.shared.mailUser);
        }
      });
  }
}
